import { useState, useCallback } from 'react';
import { Basket } from '../../types';

export const useBasketManager = (initialBaskets?: Basket[]) => {
  const [baskets, setBaskets] = useState<Basket[]>(initialBaskets || []);

  const handleAddBasket = useCallback(() => {
    const newBasket: Basket = {
      id: `basket-${Date.now()}`,
      name: `New Basket ${baskets.length + 1}`,
      symbols: [],
      profitTarget: '5',
      stopLoss: '2',
      valueAtRisk: '10',
      isAiManaged: false
    };
    
    setBaskets(prev => [...prev, newBasket]);
  }, [baskets.length]);

  const handleUpdateBasket = useCallback(
    (id: string, updates: Partial<Basket>) => {
      setBaskets(prev => 
        prev.map(basket => 
          basket.id === id 
            ? { ...basket, ...updates } 
            : basket
        )
      );
    },
    []
  );

  const handleRemoveBasket = useCallback((id: string) => {
    setBaskets(prev => prev.filter(basket => basket.id !== id));
  }, []);

  return {
    baskets,
    handleAddBasket,
    handleUpdateBasket,
    handleRemoveBasket
  };
};
